import React, { Component } from "react";
import { Navbar, Nav, NavItem, MenuItem, Form, FormGroup, FormControl, Button, NavDropdown, Media, Modal, Popover, OverlayTrigger } from 'react-bootstrap'
import { Link } from "react-router-dom"
import { connect } from 'react-redux'
import {
    fetchSearchInput, setInterval, fetchProducts, fetchCartProducts,
    updateCartProducts, fetchExtraCartProducts, updateCartExtraProducts,
    clearOverlay
} from '../actions'
import { getMoneyFormat, cuttingLongText } from '../utils'
import _ from 'lodash'
//import AlertContainer from 'react-alert'
class NavbarCart extends Component {

    state = {
        showModal: false,
        showExtraProductModal: false,
        product_name: '',
        product_id: '',
        cartshaked: false,
        popover: { product_name: 'name', product_amount: '1', product_unit: 'kg' }
    }
    showAlert(product_name, product_amount, product_unit) {
        this.setState({ cartshaked: true })
        setTimeout(() => {
            this.setState({ cartshaked: false })
        }, 1000)
        setTimeout(() => {
            this.refs.overlay.hide()
            this.props.clearOverlay()
        }, 1500)
        this.refs.overlay.show()
    }
    getTotalProduct() {
        let totalproduct = 0
        _.map(this.props.cart_products, product => {
            totalproduct += 1
        })
        return totalproduct
    }
    getTotalExtraProduct() {
        let totalproduct = 0
        _.map(this.props.cart_extraproducts, product => {
            totalproduct += 1
        })
        return totalproduct
    }
    getTotalPrice() {
        let totalPrice = 0
        _.map(this.props.cart_products, product => {
            totalPrice += product.product_amount * product.product_price_unit
        })
        return totalPrice
    }
    componentWillMount() {
        this.props.fetchCartProducts()
        this.props.fetchExtraCartProducts()
    }
    onTextAmountChange(value, product_id) {
        let decimal = (value % 1).toFixed(12)
        let decimal_count = 0
        for (var i = 2; i < decimal.length; i++) {
            if (decimal[i] != 0) {
                decimal_count += 1
            } else {
                break
            }
        }
        let products = JSON.parse(JSON.stringify(this.props.cart_products))
        if ((value >= 0 || value == '') && decimal_count < 2) {
            products[product_id]['product_amount'] = value
            this.props.updateCartProducts(products)
        }
        // else {
        //     let newState = { showModal: true, product_name: products[product_id]['product_name'], product_id: product_id }
        //     this.setState({ ...newState })
        // }
    }
    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(nextProps.overlay_trigger) != JSON.stringify(this.props.overlay_trigger) && nextProps.overlay_trigger != '') {
            this.setState({ popover: { ...nextProps.overlay_trigger } })
            this.showAlert()
        }
    }
    componentDidUpdate(prevProps, prevState) {
        // only update cart if the data has changed
        // if (JSON.stringify(prevProps.cart_products) !== JSON.stringify(this.props.cart_products) &&
        //     !_.isEmpty(prevProps.cart_products)) {
        //     //this.createNotification('success')
        //     this.showAlert()
        // }
    }
    onDelete(product_id) {
        let products = JSON.parse(JSON.stringify(this.props.cart_products))
        delete products[product_id]
        this.props.updateCartProducts(products)
    }
    onIncreaseAmount(product_id) {
        let products = JSON.parse(JSON.stringify(this.props.cart_products))
        let step = products[product_id].product_unit == 'กิโลกรัม' ? 0.1 : 1
        products[product_id]['product_amount'] = Number((products[product_id]['product_amount'] + step).toFixed(1))
        this.props.updateCartProducts(products)
    }
    onDecreaseAmount(product_id) {
        let products = JSON.parse(JSON.stringify(this.props.cart_products))
        let step = products[product_id].product_unit == 'กิโลกรัม' ? 0.1 : 1
        if (products[product_id]['product_amount'] - step > 0) {
            products[product_id]['product_amount'] = Number((Number(products[product_id]['product_amount']) - step).toFixed(12))
            this.props.updateCartProducts(products)
        } else {
            let newState = { showModal: true, product_name: products[product_id]['product_name'], product_id: product_id }
            this.setState({ ...newState })
        }
    }
    onDeleteExtraProduct(product_id) {
        let products = JSON.parse(JSON.stringify(this.props.cart_extraproducts))
        delete products[product_id]
        this.props.updateCartExtraProducts(products)
    }
    onIncreaseExtraProductAmount(product_id) {
        let products = JSON.parse(JSON.stringify(this.props.cart_extraproducts))
        products[product_id]['product_amount'] = Number((Number(products[product_id]['product_amount']) + 1).toFixed(12))
        this.props.updateCartExtraProducts(products)
    }
    onDecreaseExtraProductAmount(product_id) {
        let products = JSON.parse(JSON.stringify(this.props.cart_extraproducts))
        if (products[product_id]['product_amount'] - 1 > 0) {
            products[product_id]['product_amount'] = Number((Number(products[product_id]['product_amount']) - 1).toFixed(12))
            this.props.updateCartExtraProducts(products)
        } else {
            let newState = { showExtraProductModal: true, product_name: products[product_id]['product_name'], product_id: product_id }
            this.setState({ ...newState })
        }
    }
    handleInputErr(product_id) {
        let products = JSON.parse(JSON.stringify(this.props.cart_products))
        products[product_id]['product_amount'] = 1
        this.props.updateCartProducts(products)
    }
    renderproductincart() {
        var tmp_product = [];
        let i = 0
        _.map(this.props.cart_products, (product, index) => {
            tmp_product.push(
                <div key={i++}>
                    <div className="row" style={{ marginLeft: 10 }}>
                        <div className="col-xs-4" style={{ padding: 5 }}>
                            <div className="thumbnail-cart">
                                <img src={product.product_image_url} />
                            </div>
                        </div>
                        <div className="col-xs-7" style={{ padding: 5, marginTop: -10 }}>
                            <h4 className="product-name"><strong>{cuttingLongText(product.product_name)}</strong></h4><small>จำนวน {product.product_amount}&nbsp;{product.product_unit}</small>
                            <button type="button" className="btn btn-link btn-xs btn-delete-product pull-right" onClick={() => {
                                let newState = { showModal: true, product_name: product.product_name, product_id: product.product_id }
                                this.setState({ ...newState })
                            }}>
                                <span className="glyphicon glyphicon-trash"> </span>
                            </button>
                            <h6><strong>ราคา {getMoneyFormat((product.product_amount * product.product_price_unit).toFixed(2))} <span className="text-muted">บาท</span></strong></h6>
                        </div>
                        <div className="col-xs-2">
                        </div>
                    </div>
                    <div className="center">
                        <div className="input-group">
                            <span className="input-group-btn">
                                <button type="button" style={{
                                    border: 'none !important',
                                    color: '#ffffff !important',
                                    background: '#f57224 !important',
                                    background: '-webkit-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                    background: '-o-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                    background: '-moz-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                    background: ' linear-gradient(263deg, #f5ac24, #f57224) !important'
                                }} className="btn" onClick={() => this.onDecreaseAmount(product.product_id)}>-</button>
                            </span>
                            <input type="number" className="form-control"
                                onSelect={e => e.stopPropagation()}
                                value={product.product_amount}
                                onChange={e => this.onTextAmountChange(e.target.value, product.product_id)}
                                onBlur={() => {
                                    product.product_amount == '' || product.product_amount == 0 ?
                                        this.setState({ showModal: true, product_name: product.product_name, product_id: product.product_id })
                                        : ''
                                }}
                            />
                            <span className="input-group-btn">
                                <Button type="button" style={{
                                    border: 'none !important',
                                    color: '#ffffff !important',
                                    background: '#f57224 !important',
                                    background: '-webkit-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                    background: '-o-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                    background: '-moz-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                    background: ' linear-gradient(263deg, #f5ac24, #f57224) !important'
                                }} className="btn" onClick={() => this.onIncreaseAmount(product.product_id)}>+</Button>
                            </span>
                        </div>
                        <p></p>
                    </div>
                    <hr style={{ marginTop: 5, marginBottom: 5 }} />
                </div>
            );
        })
        if (tmp_product.length > 0) {
            return (
                <div>
                    {tmp_product}
                </div>
            )
        }
        else {
            return (
                <div style={{ marginTop: 100, textAlign: 'center' }}>
                    <span className="glyphicon glyphicon-shopping-cart mobile-cart" style={{ color: 'grey', fontSize: 20 }}></span>
                    <p>ไม่มีสินค้า</p>
                </div>
            )
        }
    }
    renderextraproductincart() {
        var tmp_product = [];
        let i = 0
        _.map(this.props.cart_extraproducts, (product, index) => {
            tmp_product.push(
                <div key={i++}>
                    <div className="row" style={{ marginLeft: 10 }}>
                        <div className="col-xs-4" style={{ padding: 5 }}>
                            <div className="thumbnail-cart">
                                <img src={product.product_image_url} />
                            </div>
                        </div>
                        <div className="col-xs-7" style={{ padding: 5, marginTop: -10 }}>
                            <h4 className="product-name"><strong>{cuttingLongText(product.product_name)}</strong></h4><small>จำนวน {product.product_amount}&nbsp;{product.product_unit}</small>
                            <button type="button" className="btn btn-link btn-xs btn-delete-product pull-right" onClick={() => {
                                let newState = { showExtraProductModal: true, product_name: product.product_name, product_id: product.product_id }
                                this.setState({ ...newState })
                            }}>
                                <span className="glyphicon glyphicon-trash"> </span>
                            </button>
                            <h6><strong> <span className="text-muted">กรุณารอการตรวจสอบราคาอีกครั้ง</span></strong></h6>
                        </div>
                        <div className="col-xs-2">
                        </div>
                    </div>
                    <div className="center">
                        <div className="input-group">
                            <span className="input-group-btn">
                                <button type="button" style={{
                                    border: 'none !important',
                                    color: '#ffffff !important',
                                    background: '#f57224 !important',
                                    background: '-webkit-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                    background: '-o-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                    background: '-moz-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                    background: ' linear-gradient(263deg, #f5ac24, #f57224) !important'
                                }} className="btn" onClick={() => this.onDecreaseExtraProductAmount(product.product_id)}>-</button>
                            </span>
                            <input type="number" className="form-control"
                                onSelect={e => e.stopPropagation()}
                                value={product.product_amount}
                                onChange={e => this.onTextAmountChange(e.target.value, product.product_id)}
                                onBlur={() => {
                                    product.product_amount == '' || product.product_amount == 0 ?
                                        this.setState({ showExtraProductModal: true, product_name: product.product_name, product_id: product.product_id })
                                        : ''
                                }}
                            />
                            <span className="input-group-btn">
                                <Button type="button" style={{
                                    border: 'none !important',
                                    color: '#ffffff !important',
                                    background: '#f57224 !important',
                                    background: '-webkit-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                    background: '-o-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                    background: '-moz-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                    background: ' linear-gradient(263deg, #f5ac24, #f57224) !important'
                                }} className="btn" onClick={() => this.onIncreaseExtraProductAmount(product.product_id)}>+</Button>
                            </span>
                        </div>
                        <p></p>
                    </div>
                    <hr style={{ marginTop: 5, marginBottom: 5 }} />
                </div>
            );
        })
        if (tmp_product.length > 0) {
            return (
                <div>
                    {tmp_product}
                </div>
            )
        }
    }
    rendermobilecart() {
        const className = `glyphicon glyphicon-shopping-cart mobile-cart ${this.state.cartshaked == true ? "cart-shaked" : ""}`;
        return (
            <div style={{ paddingLeft: 20, paddingRight: 20, paddingBottom: 5, paddingTop: 5 }}><span className={className} style={{ color: 'white', fontSize: 20, marginTop: 4 }}><span className="badge-cart">{this.getTotalProduct() + this.getTotalExtraProduct()}</span></span><div className="navheader-specialtext" style={{ fontSize: '14px !important', color: 'white !important', display: 'inline' }}>&nbsp;{getMoneyFormat(this.getTotalPrice().toFixed(2))}&nbsp;฿</div></div>
        )
    }
    onCheckout() {
        this.props.history.push('/order_review')
    }
    render() {
        const className = `glyphicon glyphicon-shopping-cart mobile-cart ${this.state.cartshaked == true ? "cart-shaked" : ""}`;
        const popoverBottom = (
            <Popover id="popover-positioned-bottom">
                คุณได้เพิ่ม <strong>{this.state.popover.product_name}</strong> <br />
                จำนวน <strong>{this.state.popover.product_amount} {this.state.popover.product_unit}</strong>
            </Popover>
        )
        return (
            <OverlayTrigger ref='overlay' trigger={null} placement="bottom" overlay={popoverBottom} rootClose={true} >
                <div style={{
                    borderColor: 'white',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderTopLeftRadius: '4px',
                    borderTopRightRadius: '4px',
                    borderBottomRightRadius: '4px',
                    borderBottomLeftRadius: '4px',
                    marginTop: '10px',
                    display: 'inline-block',
                }}>
                    <div className="hidden-lg hidden-xs" style={{ color: 'white', paddingLeft: 20, paddingRight: 20, paddingBottom: 5, paddingTop: 5 }} onClick={() => this.props.history.push('/order_review')}><span className={className} style={{ color: 'white', fontSize: 20, marginTop: 4 }}><span className="badge-cart">{this.getTotalProduct() + this.getTotalExtraProduct()}</span></span><div className="navheader-specialtext" style={{ fontSize: '14px !important', color: 'white !important', display: 'inline' }}>&nbsp;{getMoneyFormat(this.getTotalPrice().toFixed(2))}&nbsp;฿</div></div>
                    <div className="hidden-lg hidden-sm hidden-md" style={{ color: 'white', paddingLeft: 20, paddingRight: 20, paddingBottom: 5, paddingTop: 5 }} onClick={() => this.props.history.push('/order_review')}><span className={className} style={{ color: 'white', fontSize: 20, marginTop: 4 }}><span className="badge-cart">{this.getTotalProduct() + this.getTotalExtraProduct()}</span></span><div className="navheader-specialtext" style={{ fontSize: '14px !important', color: 'white !important', display: 'inline' }}>&nbsp;{getMoneyFormat(this.getTotalPrice().toFixed(2))}&nbsp;฿</div></div>
                    <NavDropdown
                        noCaret={true}
                        disabled={this.props.disabled}
                        className="hidden-xs hidden-sm hidden-md" pullRight={true} eventKey={0}
                        title={this.rendermobilecart()} id="cart-dropdown">

                        <div
                            className="navbar-cashout-area"
                        >
                            <div style={{ marginTop: 5, marginLeft: 15 }}>
                                <span className={className} style={{ margin: 0 }} aria-hidden="true"></span>สินค้าในตะกร้า</div>
                            <button onClick={() => this.onCheckout()} type="button" className="btn btn-success btn-block" style={{ width: '90%', marginLeft: 'auto', marginRight: 'auto', marginBottom: 5 }}>ชำระเงิน</button>
                        </div>
                        <hr style={{ marginTop: 5, marginBottom: 5 }} />
                        <div style={{ marginTop: 65 }}>
                            {this.renderproductincart()}
                            {this.renderextraproductincart()}
                        </div>
                    </NavDropdown>
                    {/* Modal */}
                    <Modal show={this.state.showModal}>
                        <Modal.Header>
                            <Modal.Title>ต้องการลบสินค้า {this.state.product_name} ออกจะตะกร้าใช่หรือไม่ ?</Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                            <Button bsStyle="danger" onClick={() => {
                                this.onDelete(this.state.product_id); this.setState({ showModal: false })
                            }}>ลบออก</Button>
                            <Button bsStyle="primary" onClick={() => {
                                this.setState({ showModal: false })
                                this.props.cart_products[this.state.product_id]['product_amount'] == '' || this.props.cart_products[this.state.product_id]['product_amount'] == 0 ? this.handleInputErr(this.state.product_id) : ''
                            }}>ยกเลิก</Button>
                        </Modal.Footer>
                    </Modal>
                    {/* Modal */}
                    {/* Modal */}
                    <Modal show={this.state.showExtraProductModal}>
                        <Modal.Header>
                            <Modal.Title>ต้องการลบสินค้านอกระบบ {this.state.product_name} ออกจะตะกร้าใช่หรือไม่ ?</Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                            <Button bsStyle="danger" onClick={() => {
                                this.onDeleteExtraProduct(this.state.product_id); this.setState({ showExtraProductModal: false })
                            }}>ลบออก</Button>
                            <Button bsStyle="primary" onClick={() => {
                                this.setState({ showExtraProductModal: false })
                                this.props.cart_extraproducts[this.state.product_id]['product_amount'] == '' || this.props.cart_extraproducts[this.state.product_id]['product_amount'] == 0 ? this.handleInputErr(this.state.product_id) : ''
                            }}>ยกเลิก</Button>
                        </Modal.Footer>
                    </Modal>
                    {/* Modal */}
                </div>
            </OverlayTrigger>
        )
    }
}
function mapStateToProps(state) {
    return {
        cart_products: state.cart_products_reducer,
        cart_extraproducts: state.cart_extraproducts_reducer,
        overlay_trigger: state.overlay_trigger_reducer,
    }
}
export default connect(mapStateToProps, { fetchSearchInput, setInterval, fetchProducts, fetchCartProducts, updateCartProducts, fetchExtraCartProducts, updateCartExtraProducts, clearOverlay })(NavbarCart)


// WEBPACK FOOTER //
// ./src/components/navbar_cart.js